import { DEFAULT_LOCALE, FALLBACK_LOCALE, SUPPORTED_LOCALES, isSupportedLocale, type Locale } from "@k8s-dashboard/contracts";

/**
 * 표시 언어의 단일 원천 (ADR 0025 · Issue #13)
 * --------------------------------------------------------------------------
 * 언어 목록·기본값·대체 언어는 **계약 패키지**가 소유합니다. 서버와 브라우저가
 * 같은 닫힌 집합을 보아야 "서버는 아는데 화면은 모르는 언어"가 생기지 않습니다.
 */
export { DEFAULT_LOCALE, FALLBACK_LOCALE, SUPPORTED_LOCALES, isSupportedLocale };
export type { Locale };

/** 카탈로그 이름공간. 화면이 필요할 때만 그 조각을 내려받습니다. */
export const NAMESPACES = ["agent", "approve", "common", "events", "execsession", "nav", "palette", "pod", "resourcemap", "resources", "terminal", "workload"] as const;
export type Namespace = (typeof NAMESPACES)[number];

/**
 * 셸이 첫 화면에서 반드시 필요로 하는 이름공간.
 * 나머지는 그 화면에 들어갈 때 처음 내려받습니다.
 */
export const BOOT_NAMESPACES: Namespace[] = ["common", "nav", "palette"];

/** 로컬 저장소 키. 사용자가 고른 언어는 이 키 하나에만 남습니다. */
export const LOCALE_STORAGE_KEY = "k8s-dashboard.locale";

/** URL로 언어를 고정하는 쿼리 파라미터. 링크 하나로 재현되어야 합니다. */
export const LOCALE_QUERY_PARAM = "lang";
